import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { formatDZ, convertSaveLabel } from '../../../utils/currency';
import { useCart } from '../../../context/CartContext';
import { useNavigate } from 'react-router-dom';

const FeaturedProducts = () => {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('bestsellers');

  const productTabs = [
    { id: 'bestsellers', label: 'Best Sellers', icon: 'TrendingUp' },
    { id: 'new', label: 'New Arrivals', icon: 'Sparkles' },
    { id: 'deals', label: 'Hot Deals', icon: 'Zap' }
  ];

  const products = {
    bestsellers: [
      {
        id: 1,
        name: "iPhone 15 Pro Max",
        price: 1199,
        originalPrice: 1299,
        image: "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=400&h=400&fit=crop",
        rating: 4.9,
        reviews: 2847,
        badge: "Best Seller",
        badgeColor: "bg-primary",
        inStock: true,
        quickSpecs: ["256GB Storage", "A17 Pro Chip", "48MP Camera"]
      },
      {
        id: 2,
        name: "MacBook Pro M3",
        price: 1999,
        originalPrice: 2199,
        image: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400&h=400&fit=crop",
        rating: 4.8,
        reviews: 1923,
        badge: "Pro Choice",
        badgeColor: "bg-secondary",
        inStock: true,
        quickSpecs: ["M3 Chip", "16GB RAM", "512GB SSD"]
      },
      {
        id: 3,
        name: "AirPods Pro 2nd Gen",
        price: 249,
        originalPrice: 279,
        image: "https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?w=400&h=400&fit=crop",
        rating: 4.7,
        reviews: 3456,
        badge: "Popular",
        badgeColor: "bg-accent",
        inStock: true,
        quickSpecs: ["Active Noise Cancellation", "Spatial Audio", "6hrs Battery"]
      },
      {
        id: 4,
        name: "Samsung Galaxy S24 Ultra",
        price: 1299,
        originalPrice: 1399,
        image: "https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=400&h=400&fit=crop",
        rating: 4.6,
        reviews: 1876,
        badge: "Editor\'s Choice",
        badgeColor: "bg-purple-500",
        inStock: true,
        quickSpecs: ["200MP Camera", "S Pen", "5000mAh Battery"]
      }
    ],
    new: [
      {
        id: 5,
        name: "iPad Pro M4",
        price: 1099,
        originalPrice: 1199,
        image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=400&h=400&fit=crop",
        rating: 4.8,
        reviews: 892,
        badge: "Just Launched",
        badgeColor: "bg-green-500",
        inStock: true,
        quickSpecs: ["M4 Chip", "11-inch Display", "Apple Pencil Pro"]
      },
      {
        id: 6,
        name: "Sony WH-1000XM5",
        price: 399,
        originalPrice: 449,
        image: "https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=400&h=400&fit=crop",
        rating: 4.7,
        reviews: 1234,
        badge: "New",
        badgeColor: "bg-blue-500",
        inStock: true,
        quickSpecs: ["30hrs Battery", "Industry-leading NC", "Multipoint Connection"]
      },
      {
        id: 7,
        name: "Apple Watch Series 9",
        price: 399,
        originalPrice: 429,
        image: "https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=400&h=400&fit=crop",
        rating: 4.5,
        reviews: 2156,
        badge: "Latest",
        badgeColor: "bg-red-500",
        inStock: true,
        quickSpecs: ["S9 Chip", "Always-On Display", "Health Sensors"]
      },
      {
        id: 8,
        name: "Google Pixel 8 Pro",
        price: 999,
        originalPrice: 1099,
        image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400&h=400&fit=crop",
        rating: 4.6,
        reviews: 987,
        badge: "AI Powered",
        badgeColor: "bg-yellow-500",
        inStock: true,
        quickSpecs: ["Tensor G3", "50MP Camera", "7 years updates"]
      }
    ],
    deals: [
    {
    id: 9,
    name: "Nintendo Switch OLED",
    price: 299,
    originalPrice: 349,
    image: "https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?w=400&h=400&fit=crop",
    rating: 4.4,
    reviews: 3421,
    badge: convertSaveLabel("Save $50"),
    badgeColor: "bg-orange-500",
    inStock: true,
    quickSpecs: ["7-inch OLED", "64GB Storage", "Enhanced Audio"]
    },
      {
        id: 10,
        name: "Dell XPS 13",
        price: 899,
        originalPrice: 1199,
        image: "https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400&h=400&fit=crop",
        rating: 4.3,
        reviews: 1567,
        badge: "25% Off",
        badgeColor: "bg-red-600",
        inStock: true,
        quickSpecs: ["Intel i7", "16GB RAM", "13.4-inch Display"]
      },
      {
        id: 11,
        name: "Bose QuietComfort 45",
        price: 229,
        originalPrice: 329,
        image: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400&h=400&fit=crop",
        rating: 4.5,
        reviews: 2890,
        badge: "Limited Time",
        badgeColor: "bg-pink-500",
        inStock: true,
        quickSpecs: ["24hrs Battery", "Noise Cancelling", "Comfortable Fit"]
      },
      {
        id: 12,
        name: "Samsung 4K Monitor",
        price: 349,
        originalPrice: 449,
        image: "https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=400&h=400&fit=crop",
        rating: 4.4,
        reviews: 1876,
        badge: "Flash Sale",
        badgeColor: "bg-indigo-500",
        inStock: true,
        quickSpecs: ["27-inch 4K", "HDR10", "USB-C Hub"]
      }
    ]
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="py-20 bg-gradient-to-b from-card/50 to-background">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center space-x-2 bg-secondary/10 border border-secondary/30 rounded-full px-4 py-2 mb-6">
            <Icon name="Star" size={16} className="text-secondary" />
            <span className="text-sm font-mono text-secondary">FEATURED PRODUCTS</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-secondary to-accent bg-clip-text text-transparent">
              Handpicked
            </span>
            <br />
            <span className="text-foreground">For You</span>
          </h2>
          
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Discover our most popular products, latest arrivals, and exclusive deals. 
            Each item is carefully selected for quality, performance, and customer satisfaction.
          </p>
        </motion.div>

        {/* Product Tabs */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex justify-center mb-12"
        >
          <div className="flex bg-card border border-border rounded-full p-1">
            {productTabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full transition-all duration-300 ${
                  activeTab === tab?.id
                    ? 'bg-primary text-primary-foreground shadow-lg'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
              >
                <Icon name={tab?.icon} size={18} />
                <span className="font-medium">{tab?.label}</span>
              </button>
            ))}
          </div>
        </motion.div>

        {/* Products Grid */}
        <motion.div
          key={activeTab}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {products?.[activeTab]?.map((product) => (
            <motion.div
              key={product?.id}
              variants={itemVariants}
              whileHover={{ y: -10, scale: 1.02 }}
              className="group"
            >
              <div className="holographic-card p-6 rounded-2xl h-full relative overflow-hidden">
                {/* Product Badge */}
                <div className="absolute top-4 left-4 z-10">
                  <span className={`${product?.badgeColor} text-white px-2 py-1 rounded-full text-xs font-semibold`}>
                    {product?.badge}
                  </span>
                </div>

                {/* Wishlist Button */}
                <div className="absolute top-4 right-4 z-10">
                  <Button
                    variant="ghost"
                    size="icon"
                    className="w-8 h-8 bg-background/80 backdrop-blur-sm hover:bg-background/90"
                  >
                    <Icon name="Heart" size={16} />
                  </Button>
                </div>

                {/* Product Image */}
                <div className="relative mb-6 overflow-hidden rounded-xl">
                  <div className="aspect-square bg-gradient-to-br from-muted/20 to-muted/40">
                    <Image
                      src={product?.image}
                      alt={product?.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  
                  {/* Quick Add Button */}
                  <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <Button
                      variant="default"
                      size="icon"
                      className="rounded-full shadow-lg trust-seal"
                      onClick={() => { addToCart(product, 1); navigate('/shopping-cart'); }}
                    >
                      <Icon name="Plus" size={16} />
                    </Button>
                  </div>
                </div>

                {/* Product Info */}
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                      {product?.name}
                    </h3>
                    
                    {/* Rating */}
                    <div className="flex items-center space-x-2 mb-3">
                      <div className="flex items-center space-x-1">
                        {[...Array(5)]?.map((_, i) => (
                          <Icon
                            key={i}
                            name="Star"
                            size={14}
                            className={i < Math.floor(product?.rating) ? "text-accent fill-current" : "text-muted-foreground"}
                          />
                        ))}
                      </div>
                      <span className="text-sm text-muted-foreground">
                        {product?.rating} ({product?.reviews?.toLocaleString()})
                      </span>
                    </div>

                    {/* Quick Specs */}
                    <div className="space-y-1 mb-4">
                      {product?.quickSpecs?.slice(0, 2)?.map((spec, index) => (
                        <div key={index} className="flex items-center space-x-2">
                          <div className="w-1 h-1 bg-primary rounded-full"></div>
                          <span className="text-xs text-muted-foreground">{spec}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Price and Stock */}
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <span className="text-xl font-bold text-primary">
                          {formatDZ(product?.price)}
                        </span>
                        {product?.originalPrice > product?.price && (
                          <span className="text-sm text-muted-foreground line-through">
                            {formatDZ(product?.originalPrice)}
                          </span>
                        )}
                      </div>
                      {product?.originalPrice > product?.price && (
                        <div className="text-xs text-success font-semibold">
                          {`Save ${formatDZ(product?.originalPrice - product?.price)}`}
                        </div>
                      )}
                    </div>

                    {/* Stock Status */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <div className={`inventory-pulse ${product?.inStock ? 'high' : 'low'}`}></div>
                        <span className="text-sm text-muted-foreground">
                          {product?.inStock ? 'In Stock' : 'Out of Stock'}
                        </span>
                      </div>
                      <Link to="/category-pages" className="text-sm text-primary hover:underline">
                        View Details
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Hover Effect Background */}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* View All Products CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-16"
        >
          <Link to="/category-pages">
            <Button
              variant="outline"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              className="trust-seal"
            >
              View All Products
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedProducts;